import { Box, ListItem, Text } from '@domain-group/suit-theme'

const NoQuotes = () => (
  <ListItem
    boxProps={{
      border: '1px solid',
      borderColor: 'lineColor',
      borderRadius: 5,
      marginBottom: 'medium',
      padding: 'large',
    }}
    disableHover
    forceBottomBorder
  >
    <Box flexDirection="column">
      <Text fontSize="small">No Saved Templates</Text>
      <Text
        color="bodyFontLightColor"
        marginTop="medium"
        fontSize="xsmall"
      >
        Create a new quote then save it as a template.
      </Text>
    </Box>
  </ListItem>
)

export default NoQuotes
